import { connect } from 'react-redux'
import { doSetLeftSidebarOpenState, doToggleLeftSidebar } from 'actions/app'
import { doShowHotkeysModal } from 'ducks/modals/hotkeys'
import { selectBillingProvider } from 'ducks/billing/selectors'
import {
  selectCurrentUserIsAdminOrOwner,
  selectCurrentUserSignupOlderThan,
} from 'ducks/currentUser/selectors/base'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { selectIsInInbox } from 'selectors/location'
import {
  selectMenuNoticeCounts,
  selectMenuAlerts,
  selectSettingsLandingPageAction,
} from 'selectors/menus'
import {
  selectAccountPreferenceChatEnabled,
  selectPrefersShowTopNav,
  selectIsSocialEnabled,
} from 'selectors/app/selectAccountPreferences'
import { doSetFlag, selectFlag } from 'ducks/flags'
import { HAS_SEEN_INSTALL_APP_MENU } from 'ducks/flags/flagNames'
import {
  selectShowMobileAppsMenu,
  selectReportingPermitted,
} from 'ducks/currentUser'

import View from './view'

const select = state => ({
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  isInInbox: selectIsInInbox(state),
  noticeCounts: selectMenuNoticeCounts(state),
  alerts: selectMenuAlerts(state),
  currentUserIsAdminOrOwner: selectCurrentUserIsAdminOrOwner(state),
  isChatEnabled: selectAccountPreferenceChatEnabled(state),
  isSocialEnabled: selectIsSocialEnabled(state),
  settingsLandingPageAction: selectSettingsLandingPageAction(state),
  billingProvider: selectBillingProvider(state),
  hasSeenInstallAppMenu: selectFlag(state)(HAS_SEEN_INSTALL_APP_MENU),
  // Whether the user has been a Groove customer for > than 2 weeks
  isCurrentUserSignupOlderThan2Weeks: selectCurrentUserSignupOlderThan(
    state,
    2,
    'weeks'
  ),
  showMobileAppsMenu: selectShowMobileAppsMenu(state),
  showReporting: selectReportingPermitted(state),
  showTopNav: selectPrefersShowTopNav(state),
})

const perform = dispatch => ({
  setLeftSidebarOpenState: (...args) =>
    dispatch(doSetLeftSidebarOpenState(...args)),
  showHotkeysModal: () => dispatch(doShowHotkeysModal()),
  toggleLeftSidebar: () => dispatch(doToggleLeftSidebar()),
  setSeenInstallAppMenu: () => dispatch(doSetFlag(HAS_SEEN_INSTALL_APP_MENU)),
})

export default connect(select, perform)(View)
